import { defineComponent, ref } from 'vue'
import ru from 'yup-locale-ru'
import * as yup from 'yup'

export default defineComponent({
  props: {
    agreementOpen: {
      type: Function,
      default: (value: boolean) => value
    },
    agreement: {
      type: Object,
      default: {}
    }
  },
  setup (props) {
    yup.setLocale(ru)

    function closeModalPersonalData($event: MouseEvent) {      
      // @ts-ignore
      if ($event?.target?.classList.value === 'close-personal-data-modal close' || $event?.target?.classList.value === 'overlay-personal-data-modal') {
        props.agreementOpen(false)
      }
    }

    return () => (
      <div class="overlay-personal-data-modal" onClick={($event) => closeModalPersonalData($event)}>
        <div class="personal-data-modal">
          <a class="close-personal-data-modal close" onClick={($event) => closeModalPersonalData($event)} />
          <h3 style="text-align:center;margin-bottom:10px;">Согласие на обработку персональных данных</h3>
          <div style="margin-bottom: 10px;" v-html={props.agreement.text}></div>

          {props.agreement?.file &&
              <a href={props.agreement?.file?.url} target="_blank">Политика в отношении обработки персональных данных</a>
          }

        </div>
      </div>
    )
  }
})